<!--header start-->

<app-header></app-header>

<!--header end-->

<a id="leftnav" class="vcal-btn"><span>Menu</span></a>

<app-leftsidebar [activePath]="activePath"></app-leftsidebar>
<div class="cp-main-sec">
  <div class="cp-herobanner">
    <img src="assets/images/player-banner.png" alt="" />
  </div>

  <div class="right-sec" [formGroup]="playerdetailform" [class.right-slide]="isClassAdded">
    <div class="pd-right-sec-bg">
      <div class="pd-sec-heading">
        <h1>

          <input type="text" readonly="true" [(ngModel)]="nick_name" formControlName="nickname" class="edittitle"
            placeholder="New character" />
        </h1>
        <div class="pdh-btn-sec">
          <!-- Save Button -->
          <button class="btn btn-theme btn-sm save-button d-flex align-items-center justify-content-center"
            (click)="onSave()" [disabled]="playerdetailform.invalid || creating">
            @if (!creating) {
              Save
            }
            @if (creating) {
              <div class="spinner-border spinner-border-sm text-light me-2"></div>
              Saving...
            }
          </button>

          <!-- Play and Back Buttons -->
          @if (mode === 'edit') {
            <a class="btn btn-green btn-sm play-button" (click)="navigateToPlay(playerdata)"
            >Play</a>
          }
          <a class="btn btn-dark btn-sm back-button" (click)="navigateBack()">Back</a>
        </div>
      </div>
      <div class="content-heading">required information</div>
      @if (requiredFields && requiredFields.length > 0) {
        <div class="error">
          {{ requiredFields }} is required
        </div>
      }


  <div class="row">
    <div class="col-md-12">
      <div class="pdc-top-main">
        <div class="pd-card pdcharacter">
          <h4>Character</h4>
        <div class="pd-card-char-col">

        <div class="pdcard-group">
          <div class="lbname">
            First name <span class="required-marker">*</span>
            </div>
            <input type="text" formControlName="first_name" class="editinput" />
          </div>

          <div class="pdcard-group">
            <div class="lbname">
              Last name
              </div>
              <input type="text" formControlName="last_name" class="editinput" />
            </div>

            <div class="pdcard-group">
              <div class="lbname">
                Nickname <span class="required-marker">*</span>
                </div>
                <input type="text" formControlName="nickname" [(ngModel)]="nick_name" class="editinput" />
              </div>

              <div class="pdcard-group">
                <div class="lbname">
                  Gender <span class="required-marker">*</span>
                  </div>
                  <ng-select formControlName="sex" class="wt-select editdropdown" [items]="sexualorientation_list"
                    bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                    appendTo="body">
                    <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                    <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                  </ng-select>
                </div>

                <div class="pdcard-group">
                  <div class="lbname">
                    Race <span class="required-marker">*</span>
                    </div>
                    <ng-select formControlName="race" class="wt-select editdropdown" [items]="raceList"
                      bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                      appendTo="body" groupBy="items" [selectableGroup]="false">
                      <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                      <ng-template ng-optgroup-tmp let-item="item">{{ item.label }}</ng-template>
                      <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                    </ng-select>
                  </div>
                  <div class="pdcard-group">
                    <div class="lbname">
                      Alignment <span class="required-marker">*</span>
                      </div>
                      <ng-select formControlName="alignment" class="wt-select editdropdown" [items]="alignmentlist"
                        bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                        appendTo="body">
                        <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                        <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                      </ng-select>
                    </div>

                    <div class="pdclass-lvl">
                      <div class="pdcard-group pdc-droup">
                        <div class="lbname">
                          Primary class <span class="required-marker">*</span>
                          </div>
                          <ng-select formControlName="primary_class" class="wt-select editdropdown" [items]="primary_class_list"
                            bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                            appendTo="body" groupBy="items" [selectableGroup]="false">
                            <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                            <ng-template ng-optgroup-tmp let-item="item">{{ item.label }}</ng-template>
                            <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                          </ng-select>
                        </div>

                        <div class="pdcard-group pdc-lvl">
                          <div class="lbname">
                            Lvl <span class="required-marker">*</span>
                            </div>
                            <input type="number" min="1" max="25" formControlName="primary_class_level" class="editinput" />
                          </div>
                        </div>
                        <div class="pdclass-lvl-sc">
                          <div class="pdcard-group pdc-droup-sc">
                            <div class="lbname">Secondary class</div>
                            <ng-select formControlName="secondary_class" class="wt-select editdropdown" [items]="primary_class_list"
                              bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                              appendTo="body" groupBy="items" [selectableGroup]="false">
                              <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                              <ng-template ng-optgroup-tmp let-item="item">{{ item.label }}</ng-template>
                              <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                            </ng-select>
                          </div>

                          <div class="pdcard-group pdc-lvl-sc">
                          <div class="lbname">Lvl</div>
                          <input type="number" min="1" max="25" formControlName="secondary_class_level" class="editinput" />
                        </div>
                      </div>
                      <div class="pdcard-group">
                        <div class="lbname">Modern ethnicity</div>
                        <ng-select [items]="mordern_ethnicity_list" bindLabel="value" bindValue="value" [multiple]="true"
                          [closeOnSelect]="false" formControlName="modern_ethnicity" placeholder="Choose…"
                          class="wt-select limited-height-select w-70" appendTo="body" [hideSelected]="false">
                        </ng-select>
                      </div>
                      @if (preSelectedGameSystem) {
                        <div class="pdcard-group">
                          <div class="lbname">
                            Game system
                          </div>
                          <input type="text" value="{{preSelectedGameSystem}}" class="editinput" disabled />
                        </div>
                      }


                  </div>

              </div>
              <div class="pd-card pd-attributes">
                <h4>Ability Scores</h4>
                <div class="pd-card-attri-col">
                  <div class="pdcardat-group">
                    <div class="lbname">
                      Strength <span class="required-marker">*</span>
                      </div>
                      <div class="st-qty">
                    <div class="value-button" (click)="decreaseStrength()" [class.disabled]="
                        playerdetailform.get('strength')?.value <= minValue
                      ">
                          <img src="assets/icons/icon-decrease.svg" alt="Decrease" />
                        </div>
                    <input type="number" class="number" [value]="0" formControlName="strength" readonly [disabled]="
                        playerdetailform.get('strength')?.value > maxValue
                      " [max]="maxValue" [min]="minValue" />
                    <div class="value-button" (click)="increaseStrength()" [class.disabled]="
                        playerdetailform.get('strength')?.value >= maxValue
                      ">
                            <img src="assets/icons/icon-increase.svg" alt="Increase" />
                          </div>
                        </div>
                      </div>

                      <!-- Dexterity -->
                      <div class="pdcardat-group">
                        <div class="lbname">
                          Dexterity <span class="required-marker">*</span>
                        </div>
                        <div class="st-qty">
                    <div class="value-button" (click)="decreaseDexterity()" [class.disabled]="
                        playerdetailform.get('dexterity')?.value <= minValue
                      ">
                            <img src="assets/icons/icon-decrease.svg" alt="Decrease" />
                          </div>
                          <input type="number" class="number" formControlName="dexterity" readonly [max]="maxValue"
                            [min]="minValue" />
                    <div class="value-button" (click)="increaseDexterity()" [class.disabled]="
                        playerdetailform.get('dexterity')?.value >= maxValue
                      ">
                              <img src="assets/icons/icon-increase.svg" alt="Increase" />
                            </div>
                          </div>
                        </div>

                        <!-- Constitution -->
                        <div class="pdcardat-group">
                          <div class="lbname">
                            Constitution <span class="required-marker">*</span>
                          </div>
                          <div class="st-qty">
                    <div class="value-button" (click)="decreaseConstitution()" [class.disabled]="
                        playerdetailform.get('constitution')?.value <= minValue
                      ">
                              <img src="assets/icons/icon-decrease.svg" alt="Decrease" />
                            </div>
                            <input type="number" class="number" formControlName="constitution" readonly [max]="maxValue"
                              [min]="minValue" />
                    <div class="value-button" (click)="increaseConstitution()" [class.disabled]="
                        playerdetailform.get('constitution')?.value >= maxValue
                      ">
                                <img src="assets/icons/icon-increase.svg" alt="Increase" />
                              </div>
                            </div>
                          </div>

                          <!-- Intelligence -->
                          <div class="pdcardat-group">
                            <div class="lbname">
                              Intelligence <span class="required-marker">*</span>
                            </div>
                            <div class="st-qty">
                    <div class="value-button" (click)="decreaseIntelligence()" [class.disabled]="
                                                                                    playerdetailform.get('intelligence')?.value <= minValue
                      ">
                                <img src="assets/icons/icon-decrease.svg" alt="Decrease" />
                              </div>
                              <input type="number" class="number" formControlName="intelligence" readonly [max]="maxValue"
                                [min]="minValue" />
                    <div class="value-button" (click)="increaseIntelligence()" [class.disabled]="
                                                                                    playerdetailform.get('intelligence')?.value >= maxValue
                      ">
                                  <img src="assets/icons/icon-increase.svg" alt="Increase" />
                                </div>
                              </div>
                            </div>

                            <!-- Wisdom -->
                            <div class="pdcardat-group">
                              <div class="lbname">
                                Wisdom <span class="required-marker">*</span>
                              </div>
                              <div class="st-qty">
                    <div class="value-button" (click)="decreaseWisdom()" [class.disabled]="
                                                                                    playerdetailform.get('wisdom')?.value <= minValue
                      ">
                                  <img src="assets/icons/icon-decrease.svg" alt="Decrease" />
                                </div>
                                <input type="number" class="number" formControlName="wisdom" readonly [max]="maxValue"
                                  [min]="minValue" />
                    <div class="value-button" (click)="increaseWisdom()" [class.disabled]="
                                                                                    playerdetailform.get('wisdom')?.value >= maxValue
                      ">
                                    <img src="assets/icons/icon-increase.svg" alt="Increase" />
                                  </div>
                                </div>
                              </div>


                              <!-- Charisma -->
                              <div class="pdcardat-group">
                                <div class="lbname">
                                  Charisma <span class="required-marker">*</span>
                                </div>
                                <div class="st-qty">
                    <div class="value-button" (click)="decreaseCharisma()" [class.disabled]="
                        playerdetailform.get('charisma')?.value <= minValue
                      ">
                                    <img src="assets/icons/icon-decrease.svg" alt="Decrease" />
                                  </div>
                                  <input type="number" class="number" formControlName="charisma" readonly [max]="maxValue"
                                    [min]="minValue" />
                    <div class="value-button" (click)="increaseCharisma()" [class.disabled]="
                        playerdetailform.get('charisma')?.value >= maxValue
                      ">
                                      <img src="assets/icons/icon-increase.svg" alt="Increase" />
                                    </div>
                                  </div>
                                </div>


                                    </div>
                                  </div>

                                  <div class="pd-card portrait">
                                    <div class="port-header">
                                      <div class="inner-first-wrapper d-flex align-items-center justify-content-start">
                                        <span class="required-marker">*</span>
                                        <h4>Portrait</h4>
                                      </div>

                                      @if (mode === 'edit') {
                                        <div class="btn-generate-sec">
                                          <button class="btn btn-dark" (click)="generateRegeneratePortrait()">
                                            <img src="assets/icons/icon-generate.svg" alt="" />
                                          </button>
                                        </div>
                                      }
                                    </div>

                                    <div class="profile-generate-main">
                                      <div class="d-flex justify-content-center align-items-center"
                  (click)="uploadPotrait(playerdata || uploadedimage || null)" [ngClass]="
                    playerdata?.regular_image || uploadedimage
                      ? 'pg-profile-big'
                      : 'pg-profile-file'
                  ">
                                        <!-- Show uploaded image if it exists -->
                                        @if (mode === 'edit') {
                                          @if (playerdata?.regular_image !== null) {
                                            <img [src]="image_url + playerdata?.regular_image"
                                              alt="" />
                                          }
                                        } @else {
                                          <!-- Show newly uploaded image if no playerdata image exists but uploadedimage exists -->
                                          @if (uploadedimage) {
                                            <img [src]="uploadedimage?.regular_image" alt="" />
                                          }
                                          <!-- Show upload placeholder if no images exist -->
                                          @if (!playerdata?.regular_image && !uploadedimage) {
                                            <div class="btn-generate-sec-p">
                                              <div class="pgp-file-inr">
                                                <svg viewBox="0 0 228 228" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path
                                                    d="M156.327 80.5042C156.327 103.881 137.376 122.831 114 122.831V127.497C139.954 127.497 160.993 106.458 160.993 80.5042H156.327ZM114 122.831C90.6238 122.831 71.6735 103.881 71.6735 80.5042H67.007C67.007 106.458 88.0465 127.497 114 127.497V122.831ZM71.6735 80.5042C71.6735 57.1279 90.6238 38.1777 114 38.1777V33.5112C88.0465 33.5112 67.007 54.5507 67.007 80.5042H71.6735ZM114 38.1777C137.376 38.1777 156.327 57.1279 156.327 80.5042H160.993C160.993 54.5507 139.954 33.5112 114 33.5112V38.1777ZM80.5052 160.992H147.495V156.326H80.5052V160.992ZM4.68382 113.999C4.68382 53.6254 53.6264 4.68284 114 4.68284V0.016377C51.0492 0.016377 0.0173535 51.0482 0.0173535 113.999H4.68382ZM114 4.68284C174.374 4.68284 223.316 53.6254 223.316 113.999H227.983C227.983 51.0482 176.951 0.016377 114 0.016377V4.68284ZM223.316 113.999C223.316 145 210.415 172.984 189.682 192.881L192.913 196.248C214.525 175.507 227.983 146.323 227.983 113.999H223.316ZM189.682 192.881C170.038 211.733 143.374 223.315 114 223.315V227.982C144.626 227.982 172.435 215.9 192.913 196.248L189.682 192.881ZM147.495 160.992C168.029 160.992 185.153 175.617 189.009 195.019L193.586 194.11C189.304 172.566 170.299 156.326 147.495 156.326V160.992ZM114 223.315C84.6262 223.315 57.9624 211.733 38.3186 192.881L35.0875 196.248C55.5654 215.9 83.3743 227.982 114 227.982V223.315ZM38.3186 192.881C17.5854 172.984 4.68382 145 4.68382 113.999H0.0173535C0.0173535 146.323 13.4754 175.507 35.0875 196.248L38.3186 192.881ZM80.5052 156.326C57.7016 156.326 38.6962 172.566 34.4146 194.11L38.9915 195.019C42.8476 175.617 59.9711 160.992 80.5052 160.992V156.326Z"
                                                    fill="white" fill-opacity="0.2" />
                                                  </svg>
                                                </div>
                                              </div>
                                            }
                                          }
                                        </div>
                                        @if (mode !== 'edit' || !mode) {
                                          <button class="btn btn-dark mb-2" (click)="generateRegeneratePortrait()"
                                            [disabled]="!this.isFormValidExceptRegularImage()">
                                            Generate portrait<img src="assets/icons/icon-generate.svg" alt="" />
                                          </button>
                                        }
                                    </div>
                                  </div>
                                </div>

                                <div class="pd-card pdcard-appearance">
                                  <h4>Basic Appearance</h4>
                                  <div class="pd-card-appea-col-main">
                                    <div class="pd-card-appea-col-left">
                                      <div class="pdcardappea-group">
                                        <div class="lbname">
                                          Age <span class="required-marker">*</span>
                                          </div>
                                          <input type="number" formControlName="age" [min]="1" [max]="9999" class="editinput" />
                                        </div>

                                        <div class="pdcardappea-group">
                                          <div class="lbname">
                                            Height (In) <span class="required-marker">*</span>
                                            </div>
                                            <input type="number" formControlName="height" class="editinput" />
                                          </div>
                                          <div class="pdcardappea-group">
                                            <div class="lbname">
                                              Weight (lbs) <span class="required-marker">*</span>
                                              </div>
                                              <input type="number" class="editinput" formControlName="weight" />
                                            </div>
                                            <div class="pdcardappea-group">
                                              <div class="lbname">Posture</div>
                                              <ng-select formControlName="posture" class="wt-select editdropdown" [items]="postures"
                                                bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                                                appendTo="body">
                                                <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                                <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                                              </ng-select>
                                            </div>

                                            <div class="pdcardappea-group">
                                              <div class="lbname">
                                                Body shape
                                                </div>
                                                <ng-select formControlName="body_shape" class="wt-select editdropdown" [items]="body_shapes"
                                                  bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                                                  appendTo="body">
                                                  <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                                  <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                                                </ng-select>
                                              </div>

                                              <div class="pdcardappea-group">
                                                <div class="lbname">
                                                  Physical build
                                                  </div>
                                                  <ng-select formControlName="physical_build" class="wt-select editdropdown" [items]="physical_list"
                                                    bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                                                    appendTo="body">
                                                    <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                                    <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                                                  </ng-select>
                                                </div>

                                                <div class="pdcardappea-group">
                                                <div class="lbname">Walking gait</div>
                                                <ng-select formControlName="walking_gate" class="wt-select editdropdown" [items]="walking_gate_list"
                                                  bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                                                  appendTo="body">
                                                  <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                                  <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                                                </ng-select>
                                              </div>
                                            </div>
                                            <div class="pd-card-appea-col-left">
                                              <div class="pdcardappea-group">
                                              <div class="lbname">Eye color</div>
                                              <input type="color" formControlName="eye_color" class="color" />
                                            </div>
                                            <div class="pdcardappea-group">
                                            <div class="lbname">Hair style</div>
                                            <ng-select formControlName="hair_style" class="wt-select editdropdown" [items]="hairList"
                                              bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                                              appendTo="body" groupBy="items" [selectableGroup]="false">
                                              <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                              <ng-template ng-optgroup-tmp let-item="item">{{ item.label }}</ng-template>
                                              <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                                            </ng-select>
                                          </div>
                                          <div class="pdcardappea-group">
                                          <div class="lbname">Hair color</div>
                                          <input type="color" formControlName="hair_color" class="color" />
                                        </div>
                                        <div class="pdcardappea-group">
                                          <div class="lbname">Facial hair style</div>
                                          <ng-select formControlName="facial_hair_style" class="wt-select editdropdown" [items]="facial_hair_list"
                                            bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                                            appendTo="body">
                                            <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                            <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                                          </ng-select>
                                        </div>
                                        <div class="pdcardappea-group">
                                          <div class="lbname">Facial hair color</div>
                                          <input type="color" formControlName="facial_hair_color" class="color" />
                                        </div>
                                        <div class="pdcardappea-group">
                                          <div class="lbname">Skin texture</div>
                                          <ng-select formControlName="skin_texture" class="wt-select editdropdown" [items]="skin_texture_list"
                                            bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                                            appendTo="body">
                                            <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                            <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                                          </ng-select>
                                        </div>
                                        <div class="pdcardappea-group">
                                          <div class="lbname">Skin color</div>
                                          <input type="color" formControlName="skin_color" class="color" />
                                        </div>

                                      </div>
                                      <div class="pd-card-appea-col-right">
                                        <button [ngClass]="{ 'btn-grey': !(mode === 'edit') }" [disabled]="!(mode === 'edit')"
                                          (click)="openWikiPage()" class="btn btn-dark">
                                          Wiki page
                                        </button>
                                        @if (mode === 'edit') {
                                          <button class="btn btn-theme" (click)="leaveParty(false)"
                                            [disabled]="playerdata?.game_details?.length === 0">
                                            Leave party
                                          </button>
                                        }
                                        @if (mode === 'edit') {
                                          <button class="btn btn-theme" (click)="retireCharacter()">
                                            Retire
                                          </button>
                                        }
                                        @if (mode === 'edit') {
                                          <button class="btn btn-theme"
                                            (click)="opendeletemodel('Character', game_details)">
                                            Delete
                                          </button>
                                        }
                                      </div>
                                    </div>
                                  </div>

                                  <div class="birth-location">
                                    <h4>Birth Location</h4>
                                    <div class="map-droupdown-main">
                                      <div class="map-droupdown">
                                        <div class="lbname">Map</div>
                                        <ng-select formControlName="map_code" class="wt-select editdropdown" [items]="mapListData"
                                          bindLabel="map_name" bindValue="map_id" placeholder="Choose…" [clearable]="false"
                                          appendTo="body">
                                          <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                          <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.map_name }}</span></ng-template>
                                        </ng-select>
                                      </div>
                                      <div class="birth-row">
                                        <span class="required-marker">*</span>
                                        @if (mapListData?.length > 0 || playerdata) {
                                          <div class="bl-box-main">
                                            <div class="bl-box-item">
                                              <div class="bl-box-l">
                                                <strong>Map:</strong>
                                              </div>
                    <div class="bl-box-r pointer pointer-cursor-link" (click)="
                        navigateToWikiWorld(
                          this.processMapName(mode)?.map_name,
                          this.processMapName(mode)?.map_id
                        )
                      ">
                                                <span>{{
                                                  this.processMapName(mode)?.map_name || ""
                                                }}</span>
                                              </div>
                                            </div>
                                            @for (key of birthLocationKeys; track key) {
                                              <div class="bl-box-item">
                                                <div class="bl-box-l">
                                                  <strong>{{ key | titlecase }}:</strong>
                                                </div>
                                                <div class="bl-box-r">
                                                  @if (birthLocation?.[key]?.length > 0) {
                                                    <span class="link-like pointer pointer-cursor-link"
                                                      (click)="openBirthLocation(key, birthLocation[key])">
                                                      {{ birthLocation[key] }}
                                                    </span>
                                                  }
                                                  @if (!birthLocation?.[key]?.length) {
                                                    <span>-</span>
                                                  }
                                                </div>
                                              </div>
                                            }
                                          </div>
                                        }
                                      </div>
                                    </div>

                                    @if (mode !== 'edit') {
                                      <div class="birthplace-btn">
                                        <p [ngStyle]="{ visibility: acceptbtn ? 'hidden' : 'visible' }">
                                          Where you were born first, raised as a little one...
                                        </p>
                                      <div>
                                        @if (cityClick) {
                                          <button class="btn btn-dark citybackbtn" (click)="backcity()" [disabled]="acceptbtn">
                                            Back
                                          </button>
                                        }
                                        &nbsp;&nbsp;
                <button (click)="acceptCity()" class="btn" [ngClass]="{
                    'btn-grey':
                      !playerdetailform.get('geography').value ||
                      playerdetailform.get('geography').value.length === 0 ||
                      acceptbtn,
                    'btn-green':
                      playerdetailform.get('geography').value &&
                      playerdetailform.get('geography').value.length > 0,
                  }" [disabled]="
                    !playerdetailform.get('geography').value ||
                    playerdetailform.get('geography').value.length === 0 ||
                    acceptbtn
                  ">
                                          ACCEPT
                                        </button>
                                      </div>
                                    </div>
                                  }
                                  <div class="map-wrapper">
                                    <div class="bgtngrops">
                                      @for (btn of filterlayers(layerlist); track btn) {
                                        <div class="btn-group-toggle" data-toggle="buttons">
                  <label class="btn headbtn" [ngClass]="[
                      btn.checked ? 'active ' : '',
                      btn.label?.toLowerCase() === 'zones'
                        ? 'disabled btn-grey active'
                        : 'btn-secondary',
                    ]">
                                            <input type="checkbox" [checked]="btn.checked" (change)="changeToggleLayer(btn)"
                                              [disabled]="btn.label?.toLowerCase() === 'zones'" />
                                              {{ btn.label }}
                                            </label>
                                          </div>
                                        }
                                      </div>
                                      <div id="map" class="h-100" #map>
                                        <div class="btn-map-icon">
                                          <button class="btnmap" (click)="triggerTokenZoom('map')">
                                            <img class="" src="assets/icons/icon-map-location.svg" />
                                          </button>
                                          <button class="btnmap" (click)="triggerZoomIn('map')">
                                            <img class="" src="assets/icons/icon-map-plus.svg" />
                                          </button>
                                          <button class="btnmap" (click)="triggerZoomOut('map')">
                                            <img class="" src="assets/icons/icon-map-minus.svg" />
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                    &nbsp;&nbsp;&nbsp;
            <div class="map-wrapper" [ngStyle]="{
                visibility: !cityClick ? 'hidden' : 'visible',
                height: cityClick ? '75vh' : '0vh',
              }">
                                      <div id="map1" class="h-100" #cityMap>
                                        <div class="btn-map-icon-city">
                                          <button class="btnmap" (click)="triggerTokenZoom('cityMap')">
                                            <img class="" src="assets/icons/icon-map-location.svg" />
                                          </button>
                                          <button class="btnmap" (click)="triggerZoomIn('cityMap')">
                                            <img class="" src="assets/icons/icon-map-plus.svg" />
                                          </button>
                                          <button class="btnmap" (click)="triggerZoomOut('cityMap')">
                                            <img class="" src="assets/icons/icon-map-minus.svg" />
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                                <div class="char-description">
                                  <h4>Character Description</h4>
                                  <div class="char-description-wrapper">
                                    <textarea formControlName="description"></textarea>
                                  </div>
                                  <div class="char-description-btn">
                                    <button class="btn btn-dark" (click)="generateDescription()">
                                      Generate<img src="assets/icons/icon-generate.svg" alt="" />
                                    </button>
                                  </div>
                                </div>
                                @if (mode === 'edit') {
                                  <div class="content-heading">
                                    GAME Details
                                  </div>
                                }

                                @if (mode === 'edit') {
                                  <div class="game-info">
                                    <h4>GAME INFORMATION</h4>
                                    <div class="game-info-inr">
                                      <div class="gi-group">
                                        <div class="lbname">Group</div>
                                        <input type="text" formControlName="group" class="editinput" />
                                      </div>
                                      <div class="gi-group gg-right">
                                        <div class="lbname">Game master</div>
                                        <input type="text" formControlName="game_master" class="editinput" />
                                      </div>
                                      <div class="gi-group">
                                        <div class="lbname">Game creator</div>
                                        <input type="text" formControlName="game_creator" class="editinput" />
                                      </div>
                                      <div class="gi-group gg-right">
                                        <div class="lbname">Map</div>
                                        <input type="text" formControlName="map" class="editinput" />
                                      </div>
                                      <div class="gi-btn-sec w-100 d-flex justify-content-end mt-2">
                                        <button type="button" class="btn btn-dark" (click)="downloadPlayerGuide()">Player guide</button>
                                      </div>
                                    </div>
                                  </div>
                                }

                                <div class="content-heading">Details</div>
                                <div class="alignment-info">
                                  <h4>Personality</h4>
                                  <div class="alignment-info-inr">
                                    <div class="ai-group justify-content-start">
                                      <div class="lbname">Chosen alignment</div>
                                      <p class="editinput readonly-field" [class.is-empty]="!playerdetailform.get('alignment').value">
                                        {{ playerdetailform.get("alignment").value || "Pick an alignment above" }}
                                      </p>
                                    </div>
                                    <div class="ai-group">
                                      <div class="lbname">Leaning towards</div>
                                      <ng-select formControlName="leaning_towards" class="wt-select editdropdown" [items]="leaning_towards"
                                        bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                                        appendTo="body">
                                        <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                        <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                                      </ng-select>
                                    </div>
                                    <div class="ai-group">
                                      <div class="lbname">Motivations</div>
                                      <ng-select formControlName="motivation" class="wt-select editdropdown" [items]="filter_motivation"
                                        bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                                        appendTo="body" groupBy="items" [selectableGroup]="false">
                                        <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                        <ng-template ng-optgroup-tmp let-item="item">{{ item.label }}</ng-template>
                                        <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                                      </ng-select>
                                    </div>
                                    <div class="ai-group">
                                      <div class="lbname">Inspirations</div>
                                      <ng-select formControlName="inspiration" class="wt-select editdropdown" [items]="filter_inspiration"
                                        bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                                        appendTo="body" groupBy="items" [selectableGroup]="false">
                                        <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                        <ng-template ng-optgroup-tmp let-item="item">{{ item.label }}</ng-template>
                                        <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                                      </ng-select>
                                    </div>
                                    <div class="ai-group">
                                      <div class="lbname">Loyalties</div>
                                      <ng-select formControlName="loyalties" class="wt-select editdropdown" [items]="filter_loyalties"
                                        bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                                        appendTo="body" groupBy="items" [selectableGroup]="false">
                                        <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                        <ng-template ng-optgroup-tmp let-item="item">{{ item.label }}</ng-template>
                                        <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                                      </ng-select>
                                    </div>
                                    <div class="ai-group">
                                      <div class="lbname">Guiding principles</div>
                                      <ng-select formControlName="guiding_principles" class="wt-select editdropdown" [items]="filter_guiding_principles"
                                        bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                                        appendTo="body" groupBy="items" [selectableGroup]="false">
                                        <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                        <ng-template ng-optgroup-tmp let-item="item">{{ item.label }}</ng-template>
                                        <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                                      </ng-select>
                                    </div>
                                  </div>
                                </div>
                                <div class="soc-edu-sec">
                                  <div class="social-info">
                                    <h4>Social and economics</h4>
                                    <div class="social-info-inr">
                                      <div class="social-group">
                                        <div class="lbname">Personal social status</div>
                                        <ng-select formControlName="personal_social_status" class="wt-select editdropdown" [items]="personal_social_status"
                                          bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                                          appendTo="body">
                                          <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                          <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                                        </ng-select>
                                      </div>
                                      <div class="social-group">
                                        <div class="lbname">Family social status</div>
                                        <ng-select formControlName="family_social_status" class="wt-select editdropdown" [items]="personal_social_status"
                                          bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                                          appendTo="body">
                                          <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                          <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                                        </ng-select>
                                      </div>
                                      <div class="social-group">
                                        <div class="lbname">Personal economic status</div>
                                        <ng-select formControlName="personal_economic_status" class="wt-select editdropdown" [items]="personal_economic_status"
                                          bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                                          appendTo="body">
                                          <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                          <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                                        </ng-select>
                                      </div>
                                      <div class="social-group">
                                        <div class="lbname">Family economic status</div>
                                        <ng-select formControlName="family_economic_status" class="wt-select editdropdown" [items]="personal_economic_status"
                                          bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                                          appendTo="body">
                                          <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                          <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                                        </ng-select>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="education-info">
                                    <h4>Education</h4>
                                    <div class="education-info-inr">
                                      <div class="education-group">
                                        <div class="lbname">Foundational learning</div>

                                        <ng-select formControlName="foundational_learning" class="wt-select editdropdown" [items]="foundational_learning"
                                          bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                                          appendTo="body">
                                          <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                          <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                                        </ng-select>
                                      </div>
                                      <div class="education-group">
                                        <div class="lbname">Apprentice training</div>

                                        <ng-select formControlName="apprentice_training" class="wt-select editdropdown" [items]="apprentice_training"
                                          bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                                          appendTo="body">
                                          <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                          <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                                        </ng-select>
                                      </div>
                                      <div class="education-group">
                                        <div class="lbname">Scholarly studies</div>

                                        <ng-select formControlName="scholarly_studies" class="wt-select editdropdown" [items]="scholarly_studies"
                                          bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                                          appendTo="body">
                                          <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                          <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                                        </ng-select>
                                      </div>
                                      <div class="education-group">
                                        <div class="lbname">Guild memberships</div>

                                        <ng-select formControlName="guild_membership" class="wt-select editdropdown" [items]="guild_memberships"
                                          bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                                          appendTo="body">
                                          <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                          <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                                        </ng-select>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="attire-info">
                                  <h4>Equipment</h4>
                                  <div class="attire-info-inr">
                                    <div class="attire-group-col">
                                      <div class="attire-group-col-left">Armor</div>
                                      <div class="attire-group-col-right">Description</div>
                                    </div>
                                    <div class="attire-group">
                                      <input type="color" formControlName="armor_color" class="color" />
                                      <div class="lbname">Armor</div>
                                      <input type="text" formControlName="armor_description" class="editinput" />
                                    </div>
                                    <div class="attire-group">
                                      <input type="color" formControlName="helmet_color" class="helmet_color" />
                                      <div class="lbname">Helmet</div>
                                      <input type="text" formControlName="helmet_description" class="editinput" />
                                    </div>
                                    <div class="attire-group">
                                      <input type="color" formControlName="shield_color" class="color" />
                                      <div class="lbname">Shield</div>
                                      <input type="text" formControlName="shield_description" class="editinput" />
                                    </div>
                                  </div>
                                  <div class="attire-info-inr">
                                    <div class="attire-group-col">
                                      <div class="attire-group-col-left text-uppercase custom-width">Clothing / Accessories</div>
                                    </div>
                                    <div class="attire-group">
                                      <input type="color" formControlName="head_color" class="color" />
                                      <div class="lbname">Head</div>
                                      <input type="text" formControlName="head_description" class="editinput" />
                                    </div>
                                    <div class="attire-group">
                                      <input type="color" formControlName="face_color" class="color" />
                                      <div class="lbname">Face</div>
                                      <input type="text" formControlName="face_description" class="editinput" />
                                    </div>
                                    <div class="attire-group">
                                      <input type="color" formControlName="neck_color" class="color" />
                                      <div class="lbname">Neck</div>
                                      <input type="text" formControlName="neck_description" class="editinput" />
                                    </div>
                                    <div class="attire-group">
                                      <input type="color" formControlName="shoulder_color" class="color" />
                                      <div class="lbname">Shoulders</div>
                                      <input type="text" formControlName="shoulder_description" class="editinput" />
                                    </div>
                                    <div class="attire-group">
                                      <input type="color" formControlName="torso_color" class="color" />
                                      <div class="lbname">Torso</div>
                                      <input type="text" formControlName="torso_description" class="editinput" />
                                    </div>
                                    <div class="attire-group">
                                      <input type="color" formControlName="hands_color" class="color" />
                                      <div class="lbname">Hands</div>
                                      <input type="text" formControlName="hands_description" class="editinput" />
                                    </div>
                                    <div class="attire-group">
                                      <input type="color" formControlName="waist_color" class="color" />
                                      <div class="lbname">Waist</div>
                                      <input type="text" formControlName="waist_description" class="editinput" />
                                    </div>
                                    <div class="attire-group">
                                      <input type="color" formControlName="legs_color" class="color" />
                                      <div class="lbname">Legs</div>
                                      <input type="text" formControlName="legs_description" class="editinput" />
                                    </div>
                                    <div class="attire-group">
                                      <input type="color" formControlName="feet_color" class="color" />
                                      <div class="lbname">Feet</div>
                                      <input type="text" formControlName="feet_description" class="editinput" />
                                    </div>
                                    <div class="attire-group">
                                      <input type="color" formControlName="back_color" class="color" />
                                      <div class="lbname">Back</div>
                                      <input type="text" formControlName="back_description" class="editinput" />
                                    </div>
                                    <div class="attire-group">
                                      <input type="color" formControlName="accessories_color" class="accessories_color" />
                                      <div class="lbname">Accessories</div>
                                      <input type="text" formControlName="accessories_description" class="editinput" />
                                    </div>
                                    <div class="attire-group">
                                      <input type="color" formControlName="cloak_color" class="color" />
                                      <div class="lbname">Cloak</div>
                                      <input type="text" formControlName="cloak_description" class="editinput" />
                                    </div>
                                    <div class="attire-group">
                                      <input type="color" formControlName="hat_color" class="color" />
                                      <div class="lbname">Hat</div>
                                      <input type="text" formControlName="hat_description" class="editinput" />
                                    </div>
                                  </div>
                                </div>

                                <div class="attire-info">
                                  <h4>Weapons</h4>
                                  <div class="attire-info-inr">
                                    <div class="attire-group-col">
                                      <div class="attire-group-col-left">Weapon</div>
                                      <div class="attire-group-col-right">Description</div>
                                    </div>
                                    <div class="attire-group">
                                      <input type="color" formControlName="primary_weapon_color" class="color" />
                                      <div class="lbname">Primary Weapon</div>
                                      <input type="text" formControlName="primary_weapon_description" class="editinput" />
                                    </div>
                                    <div class="attire-group">
                                      <input type="color" formControlName="secondary_weapon_color" class="color" />
                                      <div class="lbname">Secondary Weapon</div>
                                      <input type="text" formControlName="secondary_weapon_description" class="editinput" />
                                    </div>
                                  </div>
                                </div>

                                <div class="fpm-info">
                                  <div class="fpm-header">
                                    <h4>Familiar / Pet / mount</h4>
                                    <button class="btn btn-green btn-add" (click)="addPetRow()">
                                      <img src="assets/icons/icon-add.svg" alt="" />
                                    </button>
                                  </div>
                                  @if (petRows) {
                                    <div class="fpm-info-inr" formArrayName="pets">
                                      @for (pet of petRows.controls; track pet; let i = $index) {
                                        <ng-container [formGroupName]="i">
                                          <div class="fpm-group-col">
                                            <div class="fpm-col-1">Color</div>
                                            <div class="fpm-col-2">Type</div>
                                            <div class="fpm-col-3">Name</div>
                                            <div class="fpm-col-4">Description</div>
                                          </div>
                                          <div class="fpm-group">
                                            <input type="color" formControlName="color" class="color" />
                                            <ng-select formControlName="type" class="wt-select editdropdown fpm-type" [items]="pet_familiar_mount_list"
                                              bindLabel="value" bindValue="value" placeholder="Choose…" [clearable]="false"
                                              appendTo="body">
                                              <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                              <ng-template ng-option-tmp let-item="item"><span [title]="item.detail || ''">{{ item.value }}</span></ng-template>
                                            </ng-select>
                                            <input type="text" formControlName="name" max="16" class="editinput fpm-name" />
                                            <input type="text" formControlName="description" class="editinput fpm-desc" />
                                          </div>
                                        </ng-container>
                                      }
                                    </div>
                                  }

                                  <div class="d-flex align-items-center justify-content-end w-100">
                                    @if (petRows.length > 1) {
                                      <button class="btn btn-theme btn-sm btn-remove"
                                        (click)="removePetRow(petRows.controls.length - 1)">
                                        <img src="assets/icons/icon-minus.svg" alt="" />
                                      </button>
                                    }
                                  </div>
                                </div>

                                <div class="tatto-info">
                                  <div class="tatto-header">
                                    <h4>Tattoo/ Scar/ Percings</h4>
                                    <button class="btn btn-green btn-add" (click)="addBodyModificationsRow()">
                                      <img src="assets/icons/icon-add.svg" alt="" />
                                    </button>
                                  </div>

                                  @if (bodyModificationsRows.controls) {
                                    <div class="tatto-info-inr" formArrayName="body_modifications">
                                      @for (
                                        body_modification of bodyModificationsRows.controls; track
                                        body_modification; let i = $index) {
                                        <ng-container [formGroupName]="i">
                                          <div class="tatto-group-col">
                                            <div class="tatto-col-1">Color</div>
                                            <div class="tatto-col-2">Type</div>
                                            <div class="tatto-col-3">Description</div>
                                          </div>
                                          <div class="tatto-group">
                                            <input type="color" formControlName="color" class="color" />
                                            <ng-select formControlName="type" class="wt-select editdropdown tatto-type" [items]="tattoos_scars_piercings_options"
                                              bindLabel="detail" bindValue="value" placeholder="Choose…" [clearable]="false"
                                              appendTo="body">
                                              <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                                            </ng-select>
                                            <input type="text" formControlName="description" class="editinput tatto-desc" />
                                          </div>
                                        </ng-container>
                                      }
                                    </div>
                                  }

                                  <div class="d-flex align-items-center justify-content-end w-100">
                                    @if (bodyModificationsRows.length > 1) {
<button class="btn btn-theme btn-sm btn-remove" (click)="
                  removeBodyModificationsRow(
                    bodyModificationsRows.controls.length - 1
                  )
                ">
                                        <img src="assets/icons/icon-minus.svg" alt="" />
                                      </button>
                                    }
                                  </div>
                                </div>


                                <div class="char-description">
                                  <h4>Character Backstory</h4>
                                  <div class="char-description-wrapper">
                                    <textarea formControlName="backstory"></textarea>
                                  </div>
                                  <div class="char-description-btn">
                                    <button class="btn btn-dark" (click)="generateBackstory()">
                                      Generate<img src="assets/icons/icon-generate.svg" alt="" />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!--footer start-->
                      <app-footer></app-footer>

                      <!--footer end-->